import gql from 'graphql-tag';

export const CustomMessageDetails = gql`
  fragment CustomMessageDetails on CustomMessage {
    id
    type
    name
    sequence_number
    is_default
    body
    email_subject
    email_body
    created_at
    updated_at
  }
`;
